import { DEFAULT_CONFIG } from './constants.js';
import { getAddButtons } from './getAddButtons.js';
import { EMOJI_TYPE } from './types.js';
import 'react';
import './icons/FaBell.js';
import './icons/FaFlag.js';
import './icons/FaHeart.js';
import './icons/FaPaw.js';
import './icons/FaPlane.js';
import './icons/FaRegFutbol.js';
import './icons/FaSmile.js';
import './icons/FaUtensils.js';
import 'wix-rich-content-editor-common';
import './icons/EmojiPluginIcon.js';
import './modals/InsertModal.js';
import 'ricos-context';
import 'wix-rich-content-common';
import './toolbar/emojiPreviewModal.js';
import 'prop-types';
import 'react-custom-scrollbars';
import 'wix-rich-content-ui-components';
import './dataHooks.js';
import './icons/JoyPixelsIcon.js';
import './utils/getGroupEmojis.js';
import './utils/convertUnicodeToEmoji.js';
import './utils/emojiList.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginEmoji = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULT_CONFIG), config),
    type: EMOJI_TYPE,
    getAddButtons: (config2, services) => getAddButtons(config2, services)
  };
};

export { pluginEmoji };
//# sourceMappingURL=editor.js.map
